import { Component } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-warn',
  standalone: true,
  imports: [RouterOutlet, RouterLink],
  templateUrl: './warn.component.html',
  styles: ``
})
export class WarnComponent {

    contactUs() {
        let emailAddress = environment.supportEmail;
        let subject = "OpenFLIS - Help";
        let body = "Your email body here";

        let mailtoLink = "mailto:" + emailAddress + "?subject=" + encodeURIComponent(subject);

        window.open(mailtoLink, "_blank");
    }
}
